// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class IntValue implements flatbuffers.IUnpackableObject<IntValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IntValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIntValue(bb: flatbuffers.ByteBuffer, obj?: IntValue): IntValue {
    return (obj || new IntValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIntValue(bb: flatbuffers.ByteBuffer, obj?: IntValue): IntValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IntValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startIntValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(0, value, 0);
  }

  static endIntValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIntValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    IntValue.startIntValue(builder);
    IntValue.addValue(builder, value);
    return IntValue.endIntValue(builder);
  }

  unpack(): IntValueT {
    return new IntValueT(this.value());
  }

  unpackTo(_o: IntValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): IntValueT {
    const t = new IntValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class IntValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return IntValue.createIntValue(builder, this.value);
  }

  clone(): IntValueT {
    const obj = new IntValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: IntValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyIntValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
